<template>
  <inventoryProductsList/>
</template>
<script>
import inventoryProductsList from '@/components/modules/restaurant/products/list'
export default {
  name: 'inventoryProducts',
  components: {
    inventoryProductsList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/restaurant/products/list.vue